// Windows Load Handler
import jQuery from "jquery"

(function($) {

    $(window).on('load', function(){


    });

}(jQuery));